import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import { Print } from '@mui/icons-material';




function InventoryStockList() {

  
  const {inventoryStockList,getInventoryStockList} = useAppData();
  const {companyDD, projectLocationDD,  productDD, vendorDD,getDDDataById} = useAppData();
  const gridRef = useRef();
  

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},

        {headerName: "Company", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(companyDD,params.data.companyId);
            return _data.label;
          }
        },

        

        {headerName: "Location", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(projectLocationDD,params.data.locationId);
            return _data.label;
          }
        },

        {headerName: "Product Name", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(productDD,params.data.productId);
            return _data.label;
          }
        },
        

        {field:"qty",headerName: "Qty"},

        
        {field:"updated_at",headerName: "Last Updated"},
         
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    
    
          <div className='row'>
            <div className='col-md-6'><h4>Stock List</h4></div>
            <div className='col-md-6'><button className='btn btn-outline-primary float-end mb-2' onClick={onBtnExport}><Print/> Export</button></div>
            <div className="ag-theme-alpine" style={{height: 400}}>
                <AgGridReact
                    ref={gridRef}
                    rowData={inventoryStockList}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={true}
                    onGridReady={getInventoryStockList}
                />
            </div>
          </div>
        
    
    )
}

export default InventoryStockList